export default __webpack_public_path__ + "static/media/order-zero.f810249c.png";